export const PHONE_PREFIXES = [
    { value: '+49', label: '+49', icon: 'de' },
    { value: '+43', label: '+43', icon: 'at' },
    { value: '+41', label: '+41', icon: 'ch', isDivider: true },
    { value: '+7', label: '+7', icon: 'ru' },
    { value: '+31', label: '+31', icon: 'nl' },
    { value: '+32', label: '+32', icon: 'be' },
    { value: '+33', label: '+33', icon: 'fr' },
    { value: '+34', label: '+34', icon: 'es' },
    { value: '+36', label: '+36', icon: 'hu' },
    { value: '+39', label: '+39', icon: 'it' },
    { value: '+40', label: '+40', icon: 'ro' },
    { value: '+41', label: '+41', icon: 'ch' },
    { value: '+43', label: '+43', icon: 'at' },
    { value: '+44', label: '+44', icon: 'gb' },
    { value: '+45', label: '+45', icon: 'dk' },
    { value: '+46', label: '+46', icon: 'se' },
    { value: '+47', label: '+47', icon: 'no' },
    { value: '+48', label: '+48', icon: 'pl' },
    { value: '+49', label: '+49', icon: 'de' },
    { value: '+352', label: '+352', icon: 'lu' },
    { value: '+358', label: '+358', icon: 'fi' },
    { value: '+359', label: '+359', icon: 'bg' },
    { value: '+380', label: '+380', icon: 'ua' },
    { value: '+385', label: '+385', icon: 'hr' },
    { value: '+386', label: '+386', icon: 'si' },
    { value: '+420', label: '+420', icon: 'cz' },
    { value: '+421', label: '+421', icon: 'sk' },
    { value: '+423', label: '+423', icon: 'li' }
];
export const PHONE_PREFIX_DEFAULT = { icon: 'de', value: '+49', label: '+49' };
